import React, { useEffect, useState } from 'react';
import './Pedidos.css';
import { useOrders } from '../../contexts/OrdersContext';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar/sidebar';
import PedidosCard from '../../components/pedidos card/pedidos-card';
import { Stack, Typography, Box, Container, Grid2, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Alert } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import AddIcon from '@mui/icons-material/Add';
import Button from '../../components/button';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CircularProgress from "@mui/material/CircularProgress";
import DragAndDropFileUpload from '../../components/upload/upload-file';
import Buttons from '../../components/button';

const Pedidos = () => {
    const { orders, loading, fetchOrders, exportIdentification, exportConsolidated } = useOrders();
    const [visibleOrders, setVisibleOrders] = useState(10);
    const [open, setOpen] = useState(false);
    const [openConsolidated, setOpenConsolidated] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [exporting, setExporting] = useState(false); // loader da modal
    const [error, setError] = useState("");
    const [errorConsolidated, setErrorConsolidated] = useState("");
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchOrders();
    }, []);

    const importNavigation = () => {
        navigate('/import');
    };

    const handleLoadMore = () => {
        setVisibleOrders((prev) => prev + 10);
    };

    const handleOpen = () => {
        setError("");
        setOpen(true);
    }
    const handleClose = () => {
        setError("");
        setOpen(false);
    };

    const handleOpenConsolidated = () => {
        setErrorConsolidated("");
        setOpenConsolidated(true);
    };

    const handleCloseConsolidated = () => {
        setErrorConsolidated("");
        setOpenConsolidated(false);
    };

    const handleExport = async () => {
        try {
            setError("");
            await exportIdentification(inputValue);
            setInputValue("");
            setOpen(false);
        } catch (err) {
            console.error(err);
            setError("Erro ao exportar etiqueta. Verifique e tente novamente.");
        } finally {
            setExporting(false);
        }
    }

    const handleFileSelected = (file: File) => {
        setSelectedFile(file);
        console.log("Arquivo armazenado:", file);
    };

    const handleExportConsolidated = async () => {
        if (!selectedFile) {
            setErrorConsolidated("Selecione um arquivo antes de importar.");
            return;
        }
        try {
            setExporting(true);
            setErrorConsolidated("");
            await exportConsolidated(selectedFile);
            setInputValue("");
            setOpenConsolidated(false);
        } catch (err) {
            console.error(err);
            setErrorConsolidated("Erro ao Ler o Excel consolidado. Verifique e tente novamente.");
        } finally {
            setExporting(false);
        }
    }

    return (
        <>
            <Header />
            <Sidebar />
            <Box className='pedidos-content'>
                <Box
                    className="pedidos-page-title"
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 2,
                        p: 2
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <SvgIcon className="pedidos-title-icon">
                            {<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M23.3691 9.00594L17.2441 2.88094C17.1627 2.79971 17.0662 2.7353 16.96 2.69138C16.8538 2.64747 16.7399 2.62491 16.625 2.625H6.125C5.66087 2.625 5.21575 2.80937 4.88756 3.13756C4.55937 3.46575 4.375 3.91087 4.375 4.375V23.625C4.375 24.0891 4.55937 24.5342 4.88756 24.8624C5.21575 25.1906 5.66087 25.375 6.125 25.375H21.875C22.3391 25.375 22.7842 25.1906 23.1124 24.8624C23.4406 24.5342 23.625 24.0891 23.625 23.625V9.625C23.6251 9.51006 23.6025 9.39623 23.5586 9.29001C23.5147 9.18379 23.4503 9.08726 23.3691 9.00594ZM17.5 5.61203L20.638 8.75H17.5V5.61203ZM21.875 23.625H6.125V4.375H15.75V9.625C15.75 9.85706 15.8422 10.0796 16.0063 10.2437C16.1704 10.4078 16.3929 10.5 16.625 10.5H21.875V23.625ZM18.375 14.875C18.375 15.1071 18.2828 15.3296 18.1187 15.4937C17.9546 15.6578 17.7321 15.75 17.5 15.75H10.5C10.2679 15.75 10.0454 15.6578 9.88128 15.4937C9.71719 15.3296 9.625 15.1071 9.625 14.875C9.625 14.6429 9.71719 14.4204 9.88128 14.2563C10.0454 14.0922 10.2679 14 10.5 14H17.5C17.7321 14 17.9546 14.0922 18.1187 14.2563C18.2828 14.4204 18.375 14.6429 18.375 14.875ZM18.375 18.375C18.375 18.6071 18.2828 18.8296 18.1187 18.9937C17.9546 19.1578 17.7321 19.25 17.5 19.25H10.5C10.2679 19.25 10.0454 19.1578 9.88128 18.9937C9.71719 18.8296 9.625 18.6071 9.625 18.375C9.625 18.1429 9.71719 17.9204 9.88128 17.7563C10.0454 17.5922 10.2679 17.5 10.5 17.5H17.5C17.7321 17.5 17.9546 17.5922 18.1187 17.7563C18.2828 17.9204 18.375 18.1429 18.375 18.375Z" fill="#2D7A89"/>
                            </svg>
                            }
                        </SvgIcon>
                        <Typography className="pedidos-title-name" variant="h5">
                            Pedidos
                        </Typography>
                    </Box>

                    <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={2}
                        alignItems="center"
                    >
                        <Button
                            label="Importar Amostras"
                            onClick={importNavigation}
                            backgroundColor="var(--primary-color)"
                            textColor="#fff"
                            starticon={<AddIcon />}
                            sx={{ width: { xs: "100%", sm: "200px" } }}
                        />

                        <Button
                            label="Leitor de Etiqueta"
                            onClick={handleOpen}
                            backgroundColor="var(--primary-color)"
                            textColor="#fff"
                            starticon={<AddIcon />}
                            sx={{ width: { xs: "100%", sm: "200px" } }}
                        />

                        <Button
                            label="Excel consolidado"
                            onClick={handleOpenConsolidated}
                            backgroundColor="var(--primary-color)"
                            textColor="#fff"
                            starticon={<AddIcon />}
                            sx={{ width: { xs: "100%", sm: "200px" } }}
                        />
                    </Stack>
                </Box>

                {/* Lista de pedidos */}
                {loading ? (
                    <CircularProgress sx={{ display: "block", margin: "auto", mt: 5 }} />
                ) : (
                    <Grid2 container sx={{ marginLeft: '5%', paddingTop: '2%', marginRight: '5%', gap: 3 }}>
                        {orders.length > 0 ? (
                            [...orders]
                                .sort((a, b) =>
                                    new Date(b.dateApproved || 0).getTime() - new Date(a.dateApproved || 0).getTime()
                                )
                                .slice(0, visibleOrders)
                                .map((order) => (
                                    <PedidosCard
                                        key={order.id}
                                        info={{
                                            pedido: order.externalId,
                                            cliente: order.customer.name,
                                            imported: order.imported,
                                            data: order.dateApproved
                                                ? new Date(order.dateApproved).toLocaleDateString()
                                                : "N/A",
                                            amostras: 10,
                                        }}
                                    />
                                ))

                        ) : (
                            <p>Nenhum pedido encontrado.</p>
                        )}
                    </Grid2>
                )}

                {visibleOrders < orders.length && !loading && (
                    <Grid2 container className="more-button" justifyContent="center" alignItems="center">
                        <Button
                            label="Carregar pedidos"
                            onClick={handleLoadMore}
                            backgroundColor="#fff"
                            borderColor="var(--primary-color)"
                            textColor="var(--primary-color)"
                            endicon={<ArrowForwardIcon />}
                            sx={{ width: "172px" }}
                        />
                    </Grid2>
                )}

                {/* Modal Leitor de Etiqueta */}
                <Dialog
                    open={open}
                    onClose={handleClose}
                    maxWidth="sm"
                    fullWidth
                    PaperProps={{ sx: { borderRadius: 3, p: 2 } }}
                >
                    <DialogTitle>Leitor de Etiqueta</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Etiqueta"
                            fullWidth
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            disabled={exporting}
                        />

                        {/* Mensagem de erro */}
                        {error && (
                            <Alert severity="error" sx={{ mt: 2 }}>
                                {error}
                            </Alert>
                        )}
                    </DialogContent>
                    <DialogActions sx={{ position: "relative" }}>
                        <Button
                            label="Cancelar"
                            onClick={handleClose}
                            backgroundColor="#ccc"
                            textColor="#000"
                            disabled={exporting}
                        />
                        <Button
                            label="Confirmar"
                            onClick={handleExport}
                            backgroundColor="var(--primary-color)"
                            textColor="#fff"
                            disabled={exporting}
                        />
                        {exporting && (
                            <CircularProgress
                                size={24}
                                sx={{
                                    position: "absolute",
                                    right: 16,
                                    top: "50%",
                                    marginTop: "-12px",
                                }}
                            />
                        )}
                    </DialogActions>
                </Dialog>

                {/* Modal Excel consolidado*/}
                <Dialog
                    open={openConsolidated}
                    onClose={handleCloseConsolidated}
                    maxWidth="lg"
                    fullWidth
                    PaperProps={{ sx: { borderRadius: 3, p: 2 } }}
                >
                    <DialogTitle>Excel consolidado</DialogTitle>
                    <DialogContent>
                        {exporting ? (
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: '200px',
                                gap: 2
                            }}>
                                <CircularProgress size={40} />
                                <Typography variant="h6">Gerando arquivo...</Typography>
                            </Box>
                        ) : (
                            <>
                                <Box sx={{
                                    margin: '20px', display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                    <DragAndDropFileUpload onFileSelected={handleFileSelected} />
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                                    <Typography>Extensão: .xlsx, .xls, .csv.</Typography>
                                </Box>

                                {/* Mensagem de erro */}
                                {errorConsolidated && (
                                    <Alert severity="error" sx={{ mt: 2 }}>
                                        {errorConsolidated}
                                    </Alert>
                                )}
                            </>
                        )}
                    </DialogContent>
                    <DialogActions sx={{ position: "relative" }}>
                        <Button
                            label="Cancelar"
                            onClick={handleCloseConsolidated}
                            backgroundColor="#ccc"
                            textColor="#000"
                            disabled={exporting}
                        />
                        <Button
                            label="Confirmar"
                            onClick={handleExportConsolidated}
                            backgroundColor="var(--primary-color)"
                            textColor="#fff"
                            disabled={exporting}
                        />
                        {exporting && (
                            <CircularProgress
                                size={24}
                                sx={{
                                    position: "absolute",
                                    right: 16,
                                    top: "50%",
                                    marginTop: "-12px",
                                }}
                            />
                        )}
                    </DialogActions>
                </Dialog>
            </Box>
        </>
    );
}

export default Pedidos;
